import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  href = '#comprar',
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-brand-pink text-white font-display font-bold text-xl md:text-2xl py-4 px-8 rounded-full shadow-[0_8px_0_#be185d] hover:shadow-[0_6px_0_#be185d] hover:translate-y-[2px] transition-all duration-200 text-center ${className}`} data-id="element-33">
      {text}
    </motion.a>;
}